<ng-container *ngIf="hasFeedback">
  <p class="po-font-display">{{ coverageLabel }}<span class="po-icon po-icon-info review-stats-feedback__help"
    [p-tooltip]="cardHelp.coverage" p-tooltip-position="bottom" p-append-in-body="true"></span>
    <small class="review-stats-feedback__unit">{{ coverageUnit }}</small></p>

  <div class="review-stats-feedback__coverage" role="img" [attr.aria-label]="ratedDetail">
    <span class="review-stats-feedback__coverage-fill" [style.width.%]="coverageWidth"></span>
  </div>
  <p class="review-stats-feedback__detail">{{ ratedDetail }}</p>

  <p class="po-font-text-bold review-stats-feedback__title">O que você respondeu<span
    class="po-icon po-icon-info review-stats-feedback__help" [p-tooltip]="cardHelp.resolutions"
    p-tooltip-position="bottom" p-append-in-body="true"></span></p>

  <ul class="review-stats-feedback__bars" *ngIf="hasResolutions; else noResolutions">
    <li *ngFor="let bar of resolutionBars; trackBy: trackByLabel" [title]="bar.count">
      <span class="review-stats-feedback__key">{{ bar.label }}</span>
      <span class="review-stats-feedback__track">
        <span class="review-stats-feedback__fill" [ngClass]="'review-stats-feedback__fill--' + bar.modifier"
          [style.width.%]="bar.width"></span>
      </span>
      <span class="review-stats-feedback__value">{{ bar.value }}</span>
    </li>
  </ul>

  <!-- Convite, e não três zeros: quem nunca avaliou precisa saber o que fazer, não
       confirmar que não fez. -->
  <ng-template #noResolutions>
    <p class="po-font-text-small">
      Você ainda não avaliou nenhum achado deste recorte. Abra um review e marque os
      achados como procedentes ou falso positivo — é o que calibra o modelo.
    </p>
  </ng-template>
</ng-container>
